import axios from 'axios';
import { action, computed, observable } from 'mobx';
import { user, isLoggedIn, state } from 'login';
import {LOGIN_STATUS} from './LOGIN_STATUS';
import {AddressCoordinate} from 'services/AddressCoordinate';

export class CurrentUser {
    @observable loginStatus = LOGIN_STATUS.ANONYMOUS;
    @observable stronglyIdentified = false;
    @observable impersonatorElisaId = '';
    @observable firstName = '';
    @observable lastName = '';
    @observable email = '';
    @computed get fullName() {
        return `${this.firstName} ${this.lastName}`.trim();
    }
    @observable address = new AddressCoordinate({
        street: '',
        zipCode: '',
        city: '',
        lat: 60.192059,
        lng: 24.945831,
    });

    get isImpersonated() {
        return this.impersonatorElisaId !== '';
    }

    get isLoggedIn() {
        return this.loginStatus === LOGIN_STATUS.LOGGED_IN;
    }

    constructor(userProperty, loggedInStream, loggedIn) {
        userProperty.onValue(domUser => {
            if (domUser.username && domUser.stronglyIdentified) {
                axios.get('/api/user/contactdetails')
                    .catch(() => this.updateContactDetails_(domUser, null))
                    .then(response => this.updateContactDetails_(domUser, response.data));
            } else {
                this.updateContactDetails_(domUser, null);
            }
        });

        this.updateLoggedIn(loggedIn);

        loggedInStream.onValue(this.updateLoggedIn);
    }

    @action updateLoggedIn = loggedIn => {
        this.loginStatus = loggedIn ? LOGIN_STATUS.LOGGED_IN : LOGIN_STATUS.LOGGED_OUT;
    };

    /** @private */
    @action updateContactDetails_(domUser, contactDetails) {
        this.impersonatorElisaId = domUser.elisaIdImpersonatorId;
        this.stronglyIdentified = domUser.stronglyIdentified;
        this.updateUser_(contactDetails || {});
    }

    /** @private */
    @action updateUser_({ firstName = '', lastName = '', email = '', address } = {}) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.updateAddress_(address || {});
    }

    /** @private */
    @action updateAddress_({ street = '', zipCode = '', city = '' } = {}) {
        this.address.street = street;
        this.address.zipCode = zipCode;
        this.address.city = city;
    }
}

export const currentUser = new CurrentUser(user, state, isLoggedIn());



// WEBPACK FOOTER //
// ./web/js/stores/currentUser.js